import React from 'react';
import truncate from 'truncate-markup-string';
import classNames from 'classnames';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { CARD_SUBTITLE_MAX_LENGTH } from '../../../config/constants';
import type { BaseCardProps } from '../types';

interface CardSubtitleProps extends Pick<BaseCardProps, 'subtitle'> {
  className?: string;
}

const CardSubtitle: React.FC<CardSubtitleProps> = (props) => {
  const {
    subtitle,
    className,
  } = props;

  const classes = classNames('Card__subtitle', className);

  if (!subtitle) {
    return null;
  }

  if (typeof subtitle === 'string') {
    return (
      <WysiwygField
        className={classes}
        property="schema:text"
        html={truncate(subtitle, CARD_SUBTITLE_MAX_LENGTH, '<span>', '</span>', true)}
      />
    );
  }

  return (
    <div className={classes}>
      {subtitle}
    </div>
  );
};

export default CardSubtitle;
